import type { NotificationTarget } from '@/services/notifications/types'

/** Roles do back (`UserRole`) que significam "todo mundo que manda". */
const ADMIN_LIKE_ROLES = new Set(['dstorres', 'owner', 'superadmin', 'admin'])

/**
 * Resume pra quem a notification foi endereçada, sem expor user_ids (o back já
 * agrega em `user_count`).
 */
export function formatTargetSummary(target: NotificationTarget | null | undefined): string {
  if (!target) return 'Sem targeting'

  const roles = target.roles ?? []
  const subRoles = target.sub_roles ?? []
  const channels = target.channels ?? []
  const userCount = target.user_count ?? 0

  const parts: string[] = []
  const onlyAdminRoles = roles.length > 0 && roles.every((r) => ADMIN_LIKE_ROLES.has(r))

  // Só roles administrativas e nada mais = aviso de plataforma, não endereçado.
  if (onlyAdminRoles && subRoles.length === 0 && userCount === 0 && channels.length === 0) {
    parts.push('Notificação global (admins)')
  } else {
    if (roles.length > 0) parts.push(`Para: ${roles.join(', ')}`)
    if (subRoles.length > 0) parts.push(`sub_roles: ${subRoles.join(', ')}`)
    if (userCount > 0) {
      parts.push(
        userCount === 1 ? '1 usuário específico' : `${userCount} usuários específicos`,
      )
    }
    if (channels.length > 0) {
      parts.push(channels.length === 1 ? '1 canal' : `${channels.length} canais`)
    }
  }

  return parts.length > 0 ? parts.join(' · ') : 'Sem targeting'
}
